import { render, staticRenderFns } from "./CreateMulAcctReceipt.vue?vue&type=template&id=f9f8b370&"
import script from "./CreateMulAcctReceipt.vue?vue&type=script&lang=js&"
export * from "./CreateMulAcctReceipt.vue?vue&type=script&lang=js&"
import style0 from "./CreateMulAcctReceipt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports